module.exports = __webpack_public_path__ + "img/check-mark.3997565f.svg";